var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTeammatesIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 41.6 50.7",
    style: {
      enableBackground: "new 0 0 41.6 50.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000163046862898039502860000014348223487178540209_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8,22.5c-6.2,0-11.3-5.1-11.3-11.3S14.6,0,20.8,0C27,0,32.1,5,32.1,11.3C32.1,17.5,27,22.5,20.8,22.5z M20.8,6 c-2.9,0-5.3,2.4-5.3,5.3s2.4,5.3,5.3,5.3c2.9,0,5.3-2.4,5.3-5.3C26.1,8.4,23.7,6,20.8,6C20.8,6,20.8,6,20.8,6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6,50.7H29c-1.7,0-3-1.3-3-3v-6.2c0-1.7,1.3-3,3-3s3,1.3,3,3v3.2h3.6v-8.2c0-3.9-2.9-7.1-6.7-7.6l-6.2,4.7 c-1.1,0.8-2.5,0.8-3.6,0l-6.2-4.7C8.9,29.3,6,32.5,6,36.4v8.2h4v-3.2c0-1.7,1.3-3,3-3s3,1.3,3,3v6.2c0,1.7-1.3,3-3,3H3 c-1.7,0-3-1.3-3-3V36.4c0-7.6,6.1-13.7,13.7-13.7c0.6,0,1.3,0.2,1.8,0.6l5.3,4l5.3-4c0.5-0.4,1.1-0.6,1.8-0.6 c7.5,0,13.7,6.1,13.7,13.7v11.2C41.6,49.3,40.2,50.7,38.6,50.7z"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTeammatesIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/teammates_icon.e0637cd2.svg";
export { ForwardRef as ReactComponent };